export const HOME = "/";
export const SIGN_IN = "/login";
export const DASHBOARD = "/dash/notifications";
export const DASHBOARD_NOTIFICATIONS = "/dash/notifications";
export const DASHBOARD_CLIENTS = "/dash/clients";
export const DASHBOARD_PROJECTS = "/dash/projects";
export const DASHBOARD_REPORTS = "/dash/reports";
export const DASHBOARD_SETTINGS = "/dash/settings";



// WEBPACK FOOTER //
// ./src/constants/routes.js